import {
  PhysicalClientHistoryAction,
  PhysicalClientHistoryEntry,
  PhysicalClientOrigin,
  PhysicalClientStatus,
  PhysicalClientStatusFilter,
} from "@/lib/api";

export const STATUS_LABELS: Record<PhysicalClientStatus, string> = {
  Active: "Ativo",
  Inactive: "Inativo",
  Blocked: "Bloqueado",
};

export const STATUS_FILTER_LABELS: Record<PhysicalClientStatusFilter, string> = {
  Active: "Ativos",
  Inactive: "Inativos",
  Blocked: "Bloqueados",
  All: "Todos",
};

export const STATUS_BADGE_VARIANTS: Record<PhysicalClientStatus, "success" | "secondary" | "destructive"> = {
  Active: "success",
  Inactive: "secondary",
  Blocked: "destructive",
};

export const ORIGIN_LABELS: Record<PhysicalClientOrigin, string> = {
  Portal: "Portal",
  Magento: "Magento",
  Erp: "ERP",
};

/** Ação de cada botão de situação no detalhe. */
export const STATUS_ACTION_LABELS: Record<PhysicalClientStatus, string> = {
  Active: "Reativar",
  Inactive: "Inativar",
  Blocked: "Bloquear",
};

export const HISTORY_ACTION_LABELS: Record<PhysicalClientHistoryAction, string> = {
  Create: "Cadastro",
  Update: "Edição",
  StatusChange: "Situação",
  AddressCreate: "Endereço cadastrado",
  AddressUpdate: "Endereço editado",
  AddressSetDefault: "Endereço padrão",
  AddressDeactivate: "Endereço desativado",
};

const FIELD_LABELS: Record<string, string> = {
  fullName: "nome",
  email: "e-mail",
  mobilePhone: "celular",
  phone: "telefone",
  customerGroupId: "grupo",
  erpCode: "código ERP",
};

const ADDRESS_TYPE_LABELS: Record<string, string> = { Billing: "cobrança", Shipping: "entrega" };

const isStatus = (value: unknown): value is PhysicalClientStatus =>
  typeof value === "string" && value in STATUS_LABELS;

/** Resumo legível de uma linha do histórico (o histórico nunca traz o CPF). */
export function describeHistoryChange(entry: PhysicalClientHistoryEntry): string {
  const previous = entry.previous ?? {};
  const current = entry.current ?? {};

  switch (entry.action) {
    case "Create":
      return "Cliente cadastrado.";
    case "StatusChange": {
      const from = isStatus(previous.status) ? STATUS_LABELS[previous.status] : "?";
      const to = isStatus(current.status) ? STATUS_LABELS[current.status] : "?";
      return `${from} → ${to}`;
    }
    case "Update": {
      const changed = Object.keys(FIELD_LABELS).filter(
        (field) => JSON.stringify(previous[field] ?? null) !== JSON.stringify(current[field] ?? null),
      );
      return changed.length
        ? `Alterado: ${changed.map((field) => FIELD_LABELS[field]).join(", ")}.`
        : "Sem alteração de dados.";
    }
    default: {
      const type = ADDRESS_TYPE_LABELS[String(current.addressType)] ?? "";
      const line = [current.street, current.number].filter(Boolean).join(", ");
      return `Endereço de ${type}${line ? `: ${line}` : ""}${current.isDefault ? " (padrão)" : ""}`;
    }
  }
}
